<div class="bg-light min-vh-100 d-flex flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="clearfix">
          <h1 class="float-start display-3 me-4">500</h1>
          <h4 class="pt-3">Erro interno do servidor.</h4>
          <p class="text-medium-emphasis">
            A página que você está procurando está temporariamente indisponível. Tente novamente
            mais tarde.
          </p>
        </div>
        <div class="d-flex justify-content-end">
          <patron-button variant="outline" (click)="return()">Voltar</patron-button>
        </div>
      </div>
    </div>
  </div>
</div>
